import React from 'react'
import axios from 'axios';
import SortableItem from './SortableItem'

export default class SortableList extends React.Component {

  state = {
    items: this.props.items
  };

  onSortItems = (items) => {
    this.setState({
      items: items
    });
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      axios.patch("/admin/school_resources/reorder", {
        items: this.state.items
      })
    }, 1500)
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  render() {
    const { items } = this.state;
    var listItems = items.map((item, i) => {
      return (
        <SortableItem
          key={i}
          onSortItems={this.onSortItems}
          items={items}
          sortId={i}
          item={item}
          />
      )
    })

    return (
      <table className='table'> 
        <thead>
          <tr>
            <th>Category</th>
            <th>Link</th>
            <th>Form Link</th>
          </tr>
        </thead>
      <tbody>
        {listItems}
      </tbody>
      </table> 
    )
  }
}
